import { NavItem } from '../../nav/primitives/nav-item';
import { useHomeNavItem } from './use-home-nav-item';

export const HomeNavItem = () => {
  const item = useHomeNavItem();
  return <NavItem item={item} />;
};
